import { useState, useEffect } from 'react';
import { Alert, AlertProps } from 'antd';
import './style.scss';

type AlertBarProps = {
  message: string;
  type: AlertProps['type'];
  clearAfter?: number;
  className?: string;
};

const AlertBar = ({
  message,
  type,
  clearAfter = 3000,
  className,
}: AlertBarProps) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    if (clearAfter) {
      const timer = setTimeout(() => {
        setVisible(false);
      }, clearAfter);

      return () => clearTimeout(timer);
    }
  }, [clearAfter]);

  const getAlertTypeAndColor = (
    type: AlertProps['type'],
  ): {
    alertType: 'success' | 'info' | 'warning' | 'error';
    alertColor: string;
  } => {
    switch (type) {
      case 'success':
        return { alertType: 'success', alertColor: '#d9f7be' };
      case 'error':
        return { alertType: 'error', alertColor: '#fff1f0' };
      case 'warning':
        return { alertType: 'warning', alertColor: '#ffe7ba' };
      case 'info':
        return { alertType: 'info', alertColor: '#bae0ff' };
      default:
        return { alertType: 'info', alertColor: '#bae0ff' };
    }
  };

  const classes = `alert alert-animation ${className || ''}`;

  return (
    <>
      {visible && (
        <Alert
          className={classes}
          type={getAlertTypeAndColor(type).alertType}
          style={{ backgroundColor: getAlertTypeAndColor(type).alertColor }}
          message={message}
          banner
          closable
          onClose={() => setVisible(false)}
        />
      )}
    </>
  );
};

export default AlertBar;
